
export enum UnitConversionType {
    None = 0,
    Manual = 1,
    AutoFirstRandBroker = 2,
}